import { FileDocument, Label, Successable } from '@/model';
import api from '@/rest-api';
import { RouteNames } from '@/router/route-names';
import authModule from '@/store/auth-module';
import realms from '@/store/realms';
import { defaultPersonalView } from '@/store/ui-config';
import { notEmpty } from '@/util/array-util';
import Homeview from '@/views/HomeView.vue';
import Vue, { VNode } from 'vue';

export default Vue.extend({
  name: 'HomeController',
  components: {
    Homeview,
  },

  data() {
    return {
      loading: false,
      documents: [] as FileDocument[],
      personalView: defaultPersonalView(),
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      const realm = realms.getters.main;
      const user = authModule.state.session?.userId;
      this.documents = await api.documentsFilter({
        realms: [realm].filter(notEmpty),
        users: this.personalView ? [user].filter(notEmpty) : undefined,
      });
      this.loading = false;
    },
    async save(doc: Partial<FileDocument>, editLabels: Label[], file: File | undefined, callback: Successable<FileDocument>) {
      try {
        this.loading = true;
        const savedLabels = await Promise.all(editLabels.map((l) => (l.id < 1 ? api.saveLabel(l) : Promise.resolve(l))));
        const desc = file ? await api.uploadFile(file) : doc.file;
        callback.onSuccess(await api.saveDocument({ ...doc, file: desc, labels: savedLabels.map((l) => l.id) }));
        this.load();
      } catch {
        callback.onFailure();
      }
    },
    reingest(doc: FileDocument) {
      api.ingestDescriptors(doc.id).then((desc) => {
        if (desc[0].job) {
          this.$router.push({
            name: RouteNames.DuplicateJob,
            params: { duplicateJobId: `${desc[0].job.id}` },
            query: { pipeline: 'textract' },
          });
        }
      });
    },
  },

  render(create): VNode {
    return create(
      Homeview, {
        props: {
          loading: this.loading,
          documents: this.documents,
        },
        on: {
          load: this.load,
          save: this.save,
          reingest: this.reingest,
        },
      },
    );
  },

});
